import * as _ from 'underscore';
import { IHost } from '../models/IHost';
import { Module } from '../Module';
import { GetServerInfoRequest, IGetServerInfoResult } from '../ServerApi/requests/GetServerInfoRequest';
import { IWorkerProcess } from '../ServerApi/types/IWorkerProcess';
import { ServerService } from './ServerService';

export class ServerInfoService {

  private server: ServerService;
  private translate: ng.translate.ITranslateService;

  public static $inject = ['ServerService', '$translate'];

  constructor(server: ServerService, $translate: ng.translate.ITranslateService) {
    this.server = server;
    this.translate = $translate;
  }

  public fetch(): ng.IPromise<IHost[]> {
    return this.server.sendRequest(new GetServerInfoRequest({}))
      .then<IHost[]>((result: IGetServerInfoResult) => {
        return this.makeHosts(result);
      });
  }

  // Transform the array of ServerComponentProcesses into an ordered array of Hosts
  private makeHosts(result: IGetServerInfoResult): IHost[] {
    const groupedByHosts: _.Dictionary<IWorkerProcess[]> = _.groupBy(result.processes, 'host');
    const hosts = _.map(result.workerHosts, (hostName: string) => {
      const host: IHost = {
        name: hostName,
        processes: _.groupBy(groupedByHosts[hostName], 'type'),
        isExternal: false,
      };
      return host;
    });

    // External hosts are those that host services but are not part of the cluster.
    const externalHosts = _.keys(groupedByHosts).filter((x: string) => result.workerHosts.indexOf(x) === -1);
    if (externalHosts.length > 0) {
      // We are going to merge all the external hosts into one called 'external'
      const externalProcesses: IWorkerProcess[] = _.flatten(_.map(externalHosts, (hostName: string) => groupedByHosts[hostName]));
      // Mark all the processes as external
      _.forEach(externalProcesses, (x: IWorkerProcess) => x.isExternal = true);
      const externalHost: IHost = {
        name: this.translate.instant('externalNodeName'),
        processes: _.groupBy(externalProcesses, 'type'),
        isExternal: true,
      };
      hosts.push(externalHost);
    }

    return hosts;
  }

}

Module.instance().service('ServerInfoService', ServerInfoService);
